import React from 'react';
import { CheckCircle } from 'lucide-react';
const includes = ['Protocolo RESET aplicado', 'Hojas clínicas antibloqueo', 'Sistema de toma de decisiones rápida', 'Dashboard de progreso', 'Uso en guardia', 'Seguridad en la práctica'];
export function AulaListaSection() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-25">
      <div className="max-w-xl mx-auto" data-id="element-26">
        <div className="text-center mb-8" data-id="element-27">
          <span className="bg-brand-yellow/15 text-brand-yellow text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wide mb-4 inline-block border border-brand-yellow/30" data-id="element-28">
            ⭐ EXCLUSIVO DEL PACK COMPLETO
          </span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-3" data-id="element-29">
            🧠 ¿Qué agrega el Sistema Antibloqueo™?
          </h2>
          <p className="text-sm text-gray-400 font-medium max-w-md mx-auto" data-id="element-30">
            No solo entendés…{' '}
            <span className="text-brand-yellow font-bold" data-id="element-31">
              👉 actuás en tiempo real
            </span>{' '}
            y mantenés el control mental en guardia.
          </p>
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 mb-8" data-id="element-32">
          <h3 className="text-base font-bold text-center text-brand-yellow mb-5" data-id="element-33">
            💥 ESTO INCLUYE EL SISTEMA:
          </h3>
          <div className="space-y-3" data-id="element-34">
            {includes.map((item, idx) => <div key={idx} className="flex items-center gap-3 bg-gray-800/50 p-3 rounded-lg" data-id="element-35">
                <CheckCircle className="text-brand-yellow flex-shrink-0" size={20} data-id="element-36" />
                <span className="text-sm font-semibold text-white" data-id="element-37">{item}</span>
              </div>)}
          </div>
        </div>

        <p className="text-center text-gray-500 text-xs font-medium" data-id="element-38">
          La opción más recomendada para resultados más completos
        </p>
      </div>
    </section>;
}